/**
 * Cliente HTTP para rutas publicas de Cumple (ADR-013, S3-D):
 *
 *   GET  /api/v1/public/plans   → catalogo
 *   POST /api/v1/public/signup  → sign-up self-service con trial 21d
 */
import { apiRequest } from './client.js';

export interface PublicPlan {
  code: 'starter' | 'pro' | 'enterprise';
  name: string;
  monthly_price_usd: number | null;
  yearly_price_usd: number | null;
  limits: {
    maxTemplates: number | null;
    maxSites: number | null;
    maxUsers: number | null;
  };
  features: string[];
}

export interface PublicPlansResponse {
  plans: PublicPlan[];
}

export interface SignupBody {
  organization_name: string;
  organization_slug: string;
  admin_email: string;
  admin_password: string;
  sector?: string;
  accept_terms: true;
}

export interface SignupResponse {
  tenant: { id: string; slug: string; name: string };
  admin: { id: string; email: string };
  trial: { plan_code: 'pro'; ends_at: string; days_remaining: number };
  next: { login_url: string; message: string };
}

export const publicBillingApi = {
  listPlans: () => apiRequest<PublicPlansResponse>('/api/v1/public/plans'),
  signup: (body: SignupBody) =>
    apiRequest<SignupResponse>('/api/v1/public/signup', {
      method: 'POST',
      body,
      signalAuthErrors: false,
    }),
};
